import { KatalMetricsPublisher } from './metrics';

export default function (targetId, counter?) {
  const itemToLookFor = document.getElementById(targetId);
  const counterName = counter ? counter : targetId;
  const metricsPublisher =
    KatalMetricsPublisher.newChildActionPublisherForMethod(counterName);

  if (
    itemToLookFor &&
    itemToLookFor.offsetWidth > 0 &&
    itemToLookFor.offsetHeight > 0
  ) {
    metricsPublisher.publishCounterMonitor('Success', 1);
  } else {
    metricsPublisher.publishCounterMonitor('Failure', 1);
  }
}
